// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LinkCounterController from "./link_counter_controller"
application.register("link-counter", LinkCounterController)

import SwipableController from "./swipable_controller"
application.register("swipable", SwipableController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)

import YamapController from "./yamap_controller"
application.register("yamap", YamapController)

import VideoController from "./video_controller"
application.register("video", VideoController)
